/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Decrypted inner payload of an VMUA entity registration request, as sent by SnapService. Returned by the entity-requests/parse endpoint and consumed by entity-requests/register.
 */
export interface VmuaEntityRequest { 
    /**
     * Unique identifier for this registration request.
     */
    requestId?: string;
    /**
     * Identifier of the entity being registered (e.g. vCenter UUID).
     */
    entityId?: string;
    /**
     * Type of the entity (e.g. VCENTER). Owned by SnapService.
     */
    entityType?: string;
    /**
     * Human-readable display name of the entity (e.g. vcenter3.acme.com).
     */
    entityName?: string;
    /**
     * Software version of the entity.
     */
    version?: string;
    /**
     * One-time value to prevent replay attacks.
     */
    nonce?: string;
    /**
     * Entity-specific metadata as a free-form JSON object (e.g. buildNo). Schema is defined and owned by SnapService.
     */
    metadata?: { [key: string]: any; };
    /**
     * Identifier of the associated resource.
     */
    resourceId?: string;
    /**
     * Identity that triggered the registration (e.g. admin@vsphere.local).
     */
    initiatedBy?: string;
    /**
     * Timestamp when SnapService created this request.
     */
    issuedAt?: Date;
}

